<template>
  <b-modal
      modal-class="footer-dialog custom-modal"
      data-test-path="inquiry-attachment"
      id="bv-modal-select-interface-dialog-language"
      :title="$tr('InterfaceLanguageDialog.selectLanguage','Select the Language')"
      @close="onHide"
      data-backdrop="static" data-keyboard="false"
      size="md"
      ref="modal"
  >
    <b-container class="px-0 mx-0" fluid="true">
      <b-container>
        <b-form-select v-model="language" :options="languageOptions"></b-form-select>
      </b-container>
    </b-container>
    <template #modal-footer="{close}" class="p-0">
      <FooterNavbar data-test-path="attachment-dialog-footer" class="w-100">
        <CloseButton :read-only="readOnly" @close="onHide"></CloseButton>
        <FooterButton
            type="Save"
            @save="onOk"
        >
        </FooterButton>
      </FooterNavbar>
    </template>
  </b-modal>
</template>

<style>
.custom-modal .modal-dialog {
  max-width: 300px;
  width: 90%;
}
</style>


<script>
import FooterNavbar from "@/components/navbar/FooterNavbar";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import Rpc from "@/Rpc";

export default {
  name: "InterfaceLanguageDialog",
  components: {FooterButton, FooterNavbar, CloseButton},

  async mounted() {

  },

  data: () => {
    return {
      resolve: null,
      result: null,
      readOnly: true,
      shouldRemember: false,
      language: null,
      languageOptions: [],
      form: {},
      printout: null,
      selectionLocal: [],
      error: false,
      languages: null,
    };
  },

  methods: {


    async onOk() {
      if (this.language) {
        if (this.resolve != null) {
          this.result = this.language;
          this.resolve(this.result);
          this.resolve = null;
        }
        this.$refs.modal.hide();
        this.error = false;
      } else {
        this.error = true;
      }
    },

    async onHide(ev) {
      if (this.resolve != null) {
        this.resolve(null);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },

    reset(params) {
      if (!this.languages) {
        Rpc.AppTranslations.languageInSelectedInterfaceLanguage().then(data => {
          this.languages = data;
          this.languageOptions = this.languages;
          this.language = params.selectLang ?? AppTranslations.selectedLang;
        });
      } else {
        this.language = params.selectLang ?? AppTranslations.selectedLang;
      }
      this.result = null;
      this.resolve = null;
      this.readOnly = true;
    },
  }
}
</script>
